// removed by extract-text-webpack-plugin
module.exports = {"sidebarInfo":"aZB7-PG2cZyvsy_fuj-hZ","name":"_27FbsZxEnIgDUoe2L8bwnX","infoList":"_3g1NZrYzKYx6hkYZp907Rb","hivStatus":"MX18lZ65QrdTp8VdmfmmT","hivStatusIcon":"_1YreemrH_0qkYPhTEvukzw","allergyPresent":"_2cnorM2OUpbQcq_7nG6Wah","sigHxPresent":"_1CP9alXrPoLcrKJOoEbbMl"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PatientSidebarInfo.scss
// module id = 472
// module chunks = 0